/**
 * SELECTOR DE COLORES - VERSIÓN OPTIMIZADA PARA TEMA RISE
 * Extrae datos directamente del componente variant-radios de Shopify
 */

(function() {
  'use strict';
  
  console.log('🎨 [TurboPhone] Color Selector Loading...');
  
  // Configuración
  const COLORS = {
    'Negro': '#1a1a1a',
    'Azul': '#3b82f6',
    'Púrpura': '#a855f7',
    'Blanco': '#f5f5f0',
    'Rojo': '#dc2626'
  };
  
  const COLOR_KEYWORDS = {
    'negro': ['negro', 'black', 'midnight', 'medianoche'],
    'azul': ['azul', 'blue'],
    'púrpura': ['purpura', 'purple', 'morado', 'violeta'],
    'blanco': ['blanco', 'white', 'starlight', 'estrella'],
    'rojo': ['rojo', 'red', 'product-red']
  };
  
  function normalizeText(text) {
    return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
  }
  
  function detectImageColor(img) {
    const alt = normalizeText(img.alt || '');
    const src = normalizeText(img.src || '');
    const text = alt + ' ' + src;
    
    for (const [color, keywords] of Object.entries(COLOR_KEYWORDS)) {
      for (const keyword of keywords) {
        if (text.includes(keyword)) {
          console.log(`✅ Image matched to color: ${color} (keyword: ${keyword})`);
          return color;
        }
      }
    }
    return null;
  }
  
  function getColorOptionsFromVariantRadios() {
    const colors = new Set();
    
    // Método 1: Buscar en variant-radios
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      const colorFieldset = Array.from(variantRadios.querySelectorAll('fieldset')).find(fs => {
        const legend = fs.querySelector('legend');
        return legend && normalizeText(legend.textContent).includes('color');
      });
      
      if (colorFieldset) {
        const labels = colorFieldset.querySelectorAll('label');
        labels.forEach(label => {
          const colorName = label.textContent.trim();
          if (COLORS[colorName]) {
            colors.add(colorName);
            console.log(`✅ Found color from variant-radios: ${colorName}`);
          }
        });
      }
    }
    
    // Método 2: Buscar en inputs radio
    if (colors.size === 0) {
      const colorInputs = document.querySelectorAll('input[type="radio"][name*="Color"], input[type="radio"][name*="color"]');
      colorInputs.forEach(input => {
        const label = document.querySelector(`label[for="${input.id}"]`);
        if (label) {
          const colorName = label.textContent.trim();
          if (COLORS[colorName]) {
            colors.add(colorName);
            console.log(`✅ Found color from radio input: ${colorName}`);
          }
        }
      });
    }
    
    // Método 3: Buscar en el DOM directamente
    if (colors.size === 0) {
      document.querySelectorAll('label').forEach(label => {
        const text = label.textContent.trim();
        if (COLORS[text]) {
          colors.add(text);
          console.log(`✅ Found color from label: ${text}`);
        }
      });
    }
    
    return Array.from(colors);
  }
  
  function createColorSelector(colors) {
    const container = document.createElement('div');
    container.id = 'turbophone-color-selector';
    container.style.cssText = `
      margin: 1.5rem 0;
      padding: 1.5rem;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-radius: 16px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.08);
      border: 1px solid rgba(0,0,0,0.05);
    `;
    
    const title = document.createElement('div');
    title.innerHTML = '<span style="font-size: 1.5rem;">🎨</span> <span style="font-size: 1.125rem; font-weight: 700; color: #1f2937;">Selecciona tu color</span>';
    title.style.cssText = `
      display: flex;
      align-items: center;
      gap: 0.75rem;
      margin-bottom: 1.25rem;
    `;
    container.appendChild(title);
    
    const buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = `
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
      gap: 1rem;
    `;
    
    colors.forEach((colorName, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.color = normalizeText(colorName);
      button.dataset.originalColor = colorName;
      button.className = 'turbophone-color-btn';
      
      const hexColor = COLORS[colorName];
      const isActive = index === 0;
      
      button.style.cssText = `
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.625rem;
        padding: 1rem 0.75rem;
        background: ${isActive ? 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)' : '#ffffff'};
        border: 2.5px solid ${isActive ? '#3b82f6' : '#e5e7eb'};
        border-radius: 14px;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
      `;
      
      if (isActive) {
        button.classList.add('active');
      }
      
      // Círculo de color
      const circle = document.createElement('span');
      circle.style.cssText = `
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: ${hexColor};
        box-shadow: 0 4px 12px rgba(0,0,0,0.2), inset 0 1px 2px rgba(255,255,255,0.3);
        border: ${hexColor === '#f5f5f0' ? '2px solid #d1d5db' : 'none'};
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        transform: ${isActive ? 'scale(1.2)' : 'scale(1)'};
      `;
      
      // Brillo en el círculo
      const shine = document.createElement('span');
      shine.style.cssText = `
        position: absolute;
        top: 15%;
        left: 15%;
        width: 40%;
        height: 40%;
        background: radial-gradient(circle, rgba(255,255,255,0.6) 0%, transparent 70%);
        border-radius: 50%;
        transform: rotate(-45deg);
        pointer-events: none;
      `;
      circle.appendChild(shine);
      
      // Checkmark para activo
      if (isActive) {
        const check = document.createElement('span');
        check.style.cssText = `
          position: absolute;
          top: 4px;
          right: 4px;
          width: 20px;
          height: 20px;
          background: #3b82f6;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: bold;
        `;
        check.textContent = '✓';
        button.appendChild(check);
      }
      
      // Label
      const label = document.createElement('span');
      label.textContent = colorName;
      label.style.cssText = `
        font-size: 0.875rem;
        font-weight: ${isActive ? '700' : '600'};
        color: ${isActive ? '#3b82f6' : '#4b5563'};
        text-align: center;
        transition: all 0.3s ease;
      `;
      
      button.appendChild(circle);
      button.appendChild(label);
      
      // Event handlers
      button.addEventListener('mouseenter', function() {
        if (!this.classList.contains('active')) {
          this.style.transform = 'translateY(-4px)';
          this.style.borderColor = '#9ca3af';
          this.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
          circle.style.transform = 'scale(1.15)';
        }
      });
      
      button.addEventListener('mouseleave', function() {
        if (!this.classList.contains('active')) {
          this.style.transform = 'translateY(0)';
          this.style.borderColor = '#e5e7eb';
          this.style.boxShadow = 'none';
          circle.style.transform = 'scale(1)';
        }
      });
      
      button.addEventListener('click', function() {
        console.log(`🖱️ Clicked color: ${colorName}`);
        
        // Actualizar botones
        buttonsContainer.querySelectorAll('.turbophone-color-btn').forEach(btn => {
          btn.classList.remove('active');
          btn.style.background = '#ffffff';
          btn.style.borderColor = '#e5e7eb';
          btn.style.transform = 'translateY(0)';
          btn.querySelector('span:nth-child(1)').style.transform = 'scale(1)';
          btn.querySelector('span:nth-child(2)').style.fontWeight = '600';
          btn.querySelector('span:nth-child(2)').style.color = '#4b5563';
          
          // Remover checkmark
          const oldCheck = btn.querySelector('span:last-child:not(:nth-child(1)):not(:nth-child(2))');
          if (oldCheck && oldCheck.textContent === '✓') {
            oldCheck.remove();
          }
        });
        
        // Activar botón actual
        this.classList.add('active');
        this.style.background = 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)';
        this.style.borderColor = '#3b82f6';
        this.style.transform = 'translateY(-4px)';
        this.style.boxShadow = '0 8px 24px rgba(59,130,246,0.25)';
        circle.style.transform = 'scale(1.2)';
        label.style.fontWeight = '700';
        label.style.color = '#3b82f6';
        
        // Agregar checkmark
        const check = document.createElement('span');
        check.style.cssText = `
          position: absolute;
          top: 4px;
          right: 4px;
          width: 20px;
          height: 20px;
          background: #3b82f6;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: bold;
          animation: bounce 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        `;
        check.textContent = '✓';
        this.appendChild(check);
        
        // Filtrar imágenes
        filterImages(colorName);
        
        // Actualizar variante en Shopify
        updateShopifyVariant(colorName);
      });
      
      buttonsContainer.appendChild(button);
    });
    
    // Agregar animación CSS
    const style = document.createElement('style');
    style.textContent = `
      @keyframes bounce {
        0% { transform: scale(0); opacity: 0; }
        50% { transform: scale(1.2); }
        100% { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
    
    container.appendChild(buttonsContainer);
    return container;
  }
  
  function filterImages(selectedColor) {
    console.log(`🖼️ Filtering images for: ${selectedColor}`);
    
    const images = document.querySelectorAll('.product__media img, .product__media-item img, img[src*="cdn/shop/files"]');
    let hiddenCount = 0;
    let shownCount = 0;
    
    images.forEach(img => {
      const detectedColor = detectImageColor(img);
      const parent = img.closest('.product__media-item, .product__media-wrapper, li, div[class*="media"]') || img.parentElement;
      
      if (!parent) return;
      
      parent.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
      
      if (!detectedColor) {
        // Sin color detectado - mostrar siempre
        parent.style.display = '';
        parent.style.opacity = '1';
        parent.style.transform = 'scale(1)';
        parent.style.visibility = 'visible';
        parent.style.position = 'relative';
        shownCount++;
        return;
      }
      
      const normalizedDetected = normalizeText(detectedColor);
      const normalizedSelected = normalizeText(selectedColor);
      
      if (normalizedDetected === normalizedSelected) {
        parent.style.display = '';
        parent.style.opacity = '1';
        parent.style.transform = 'scale(1)';
        parent.style.visibility = 'visible';
        parent.style.position = 'relative';
        shownCount++;
      } else {
        parent.style.display = 'none';
        parent.style.opacity = '0';
        parent.style.transform = 'scale(0.9)';
        parent.style.visibility = 'hidden';
        parent.style.position = 'absolute';
        hiddenCount++;
      }
    });
    
    console.log(`✅ Images filtered: ${shownCount} shown, ${hiddenCount} hidden`);
  }
  
  function updateShopifyVariant(colorName) {
    console.log(`🔄 Updating variant to: ${colorName}`);
    
    // Buscar el radio button correspondiente
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      const labels = variantRadios.querySelectorAll('label');
      labels.forEach(label => {
        if (label.textContent.trim() === colorName) {
          const input = label.querySelector('input') || document.getElementById(label.getAttribute('for'));
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            console.log(`✅ Variant updated successfully`);
          }
        }
      });
    }
  }
  
  function hideDefaultSelectors() {
    console.log('🙈 Hiding default Shopify selectors...');
    
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      const colorFieldsets = Array.from(variantRadios.querySelectorAll('fieldset')).filter(fs => {
        const legend = fs.querySelector('legend');
        return legend && normalizeText(legend.textContent).includes('color');
      });
      
      colorFieldsets.forEach(fs => {
        fs.style.display = 'none';
        fs.style.visibility = 'hidden';
        fs.style.opacity = '0';
        fs.style.position = 'absolute';
        fs.style.pointerEvents = 'none';
      });
      
      console.log(`✅ Hidden ${colorFieldsets.length} default color selectors`);
    }
  }
  
  function init() {
    console.log('🚀 [TurboPhone] Initializing color selector...');
    
    if (document.querySelector('#turbophone-color-selector')) {
      console.log('⚠️ Selector already exists, skipping initialization');
      return;
    }
    
    const colors = getColorOptionsFromVariantRadios();
    
    if (colors.length === 0) {
      console.warn('⚠️ No colors found - selector will not be created');
      return;
    }
    
    console.log(`✅ Found ${colors.length} colors:`, colors);
    
    const selector = createColorSelector(colors);
    
    const productForm = document.querySelector('.product-form, form[action*="/cart/add"]');
    if (!productForm) {
      console.warn('⚠️ Product form not found');
      return;
    }
    
    productForm.insertBefore(selector, productForm.firstChild);
    
    hideDefaultSelectors();
    
    setTimeout(() => {
      filterImages(colors[0]);
    }, 200);
    
    console.log('✅ [TurboPhone] Color selector initialized successfully! 🎉');
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
    setTimeout(init, 500);
  }
  
})();
